import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const checkoutUrl = 'https://usa.ebookpoint.shop/cart/54923761516916:1';
type BuyButtonProps = {
  children?: React.ReactNode;
  compact?: boolean;
};
export function BuyButton({
  children = 'Get Pickleball Pro 360 Now',
  compact = false
}: BuyButtonProps) {
  return <a href={checkoutUrl} className={`group flex w-full items-center justify-center gap-2 rounded-xl bg-sky-600 px-5 text-center font-black text-white shadow-lg shadow-sky-300/50 transition hover:bg-sky-700 focus:outline-none focus:ring-4 focus:ring-sky-200 ${compact ? 'py-3 text-sm' : 'py-4 text-base'}`} data-id="element-8">
      {children}
      <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-9" />
    </a>;
}
export { checkoutUrl };